import { Util } from "/global/js/util.min.js?v=1743070040";
const util = new Util();
export default class ProductsConditionsHandler {
  constructor() {
    this.productConditions = document.querySelector('#productConditions');
    if (this.productConditions) {
      this.productConditionsContent = this.productConditions.querySelector('#productConditionsContent');
      pubsub.on('addedToCart', data => this.updateProductConditions(data[1]));
      pubsub.on('emptyCart', () => this.updateProductConditions(null));
      pubsub.on('removedFromCart', data => this.updateProductConditions(data[1]));
    }
  }
  updateProductConditions(data) {
    if (data !== null && data.getProductSpecialConditions !== '') {
      this.productConditionsContent.innerHTML = data.getProductSpecialConditions;
      if (util.hasClass(this.productConditions, 'd-none')) {
        util.removeClass(this.productConditions, 'd-none');
      }
    } else {
      this.productConditionsContent.innerHTML = '';
      util.addClass(this.productConditions, 'd-none');
    }
  }
}